import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import Billing from "@/services/billing/billing";

export interface CreditHistoryParams {
  page?: number;
  limit?: number;
  type?: string;
}

export interface CreditTransaction {
  id: string;
  type: string;
  amountCents: number;
  balanceAfterCents: number;
  serviceKey: string | null;
  description: string | null;
  stripeInvoiceId: string | null;
  user: { id: string; email: string; name: string } | null;
  createdAt: string;
}

export interface CreditHistoryData {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  history: CreditTransaction[];
}

export function useCreditHistory(params: Ref<CreditHistoryParams>) {
  return useQuery({
    queryKey: ["billing", "creditHistory", params] as const,
    queryFn: async (): Promise<CreditHistoryData | null> => {
      const result = await Billing.getCreditHistory(params.value);
      const payload = result?.data as { status?: boolean; data?: CreditHistoryData };
      if (payload?.status && payload?.data) {
        return payload.data;
      }
      return null;
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
  });
}
